<template>
  <div>
    <div class="page-title">
      {{ $t('menu.role_list') }}
    </div>
    <div class="system-role-list page-container">

      <div class="filter-container">
        <div class="filter-container-tag">
          {{ $t('components.activity') }}
        </div>
        <el-input v-model="search.role_name" :placeholder="$t('system.role_name')" class="search-frame" clearable />
        <el-button type="primary" class="search-btn" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>

        <el-button type="primary" class="filter-btn-add mb10 " @click="showAddRoleModal"><i style="font-weight: 600" class="el-icon-plus" />{{ $t('system.add_role') }}</el-button>
      </div>
      <div class="tableContainer">
        <el-table
          v-loading="listLoading"
          :data="tableData"
          stripe
          fit
          highlight-current-row
          style="width: 100%"
        >
          <el-table-column
            label="ID"
            align="center"
            type="index"
            width="50"
          />
          <el-table-column :label="$t('system.role_name')" align="center">
            <template slot-scope="scope">
              {{ scope.row.role_name }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('system.remark')" align="center">
            <template slot-scope="scope">
              {{ scope.row.remark }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('components.operator')" align="center">
            <template slot-scope="scope">
              {{ scope.row.mch_user ? scope.row.mch_user.username : 'System' }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('components.create_time')" align="center">
            <template slot-scope="scope">
              {{ scope.row.create_time }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('components.operation')" align="center">
            <template slot-scope="scope">
              <el-button type="primary" plain size="small" @click="showUpdateRoleAuthModal(scope.row)">{{ $t('system.update_role') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <add-role-modal
        ref="addRoleAuthRef"
        :menu-list="menu_list"
        @updateRoleList="handleFilter"
      />

      <update-role-auth-modal
        ref="updateRoleAuthRef"
        :menu-list="menu_list"
        @updateRoleList="handleFilter"
      />

    </div>
  </div>
</template>

<script>
import { fetchMerchantRoles, fetchMchMenuList } from '@/api/system/system'
export default {
  name: 'System_User_List',
  components: {
    // Paginator: () => import('@/views/components/Paginator'),
    UpdateRoleAuthModal: () => import ('./components/Modal/UpdateRoleAuthModal'),
    AddRoleModal: () => import ('./components/Modal/AddRoleModal')
  },
  data() {
    return {
      search: {
        role_name: ''
      },
      tableData: [],
      auth_list: [],
      menu_list: [],
      listLoading: false
    }
  },
  mounted() {
    this.$bus.off('RE_GER_MERCHANT_ROLE')
    this.$bus.on('RE_GER_MERCHANT_ROLE', () => {
      this.handleFilter()
    })
    this.handleFilter()
    this.getMchMenuList()
  },
  methods: {
    handleFilter(params = {}) {
      if (this.search.role_name) {
        params.role_name = this.search.role_name
      }
      this.getMerchantRoles(params)
    },
    getMerchantRoles(params = {}) {
      this.listLoading = true
      fetchMerchantRoles(params).then(res => {
        this.tableData = res.data
      }).finally(() => {
        this.listLoading = false
      })
    },
    getMchMenuList(params = {}) {
      fetchMchMenuList(params).then(res => {
        this.menu_list = res.data
      })
    },
    showUpdateRoleAuthModal(row) {
      this.$refs.updateRoleAuthRef.changeModalStatus(true, row)
    },
    showAddRoleModal() {
      this.$refs.addRoleAuthRef.changeModalStatus(true)
    }
  }
}
</script>

<style scoped>
  .system-role-list{
  }
  .filter-container{
    position: relative;
    margin-bottom: 38px;
    text-align: right;
  }
  .search-frame {
    width: 160px;
    margin-left: 5px;
  }
  .search-btn {
    margin-left: 10px;
  }
  .add-btn{
    color: #fff;
  }
</style>
